import { AppActionTypes } from '../../model/application/actions';
import { BotState, Bot } from '../../model/bot/types';
import { botFillActionType, saveBotActionType, changeSelectedBotActionType, exploreBotActionType } from '../../model/bot/actions';
import produce from 'immer';
import { replaceOrInsert } from '../../helpers/immutableHelper';

const initialState: BotState = {
  bots: [],
  selectedBot: undefined
};

export function botReducer(
  state = initialState,
  action: AppActionTypes,
): BotState {
  switch (action.type) {
    case exploreBotActionType.success:
    case changeSelectedBotActionType.success:
      return {
        ...state,
        selectedBot: state.bots.filter(x => x.id === action.payload)[0].id,
      };
    case saveBotActionType.success:
      return produce(state, draftState => {
        draftState.bots = replaceOrInsert<Bot>(state.bots, action.payload);
      })
    case botFillActionType.success:
      return produce(state, draftState => {
        draftState.bots = action.payload;
        draftState.selectedBot = action.payload.length > 0 ? action.payload[0].id : undefined;
      })
    default:
      return state;
  }
}
